module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('impressao', {
    ref: "impressao",
    attrs: {
      "filtro": _vm.filtro,
      "show": _vm.showImpressao
    },
    on: {
      "close": function () {
        _vm.showImpressao = false
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('alert'), _vm._v(" "), _c('div', {
    staticClass: "box box-solid"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-3"
  }, [_c('div', {
    class: {
      'form-group': true
    }
  }, [_c('label', {
    attrs: {
      "for": "nome"
    }
  }, [_vm._v("Dia do Fechamento")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filtro.diaFechamento),
      expression: "filtro.diaFechamento"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "nome"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.filtro, "diaFechamento", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("--Selecione--")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "03"
    }
  }, [_vm._v("03")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "10"
    }
  }, [_vm._v("10")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "18"
    }
  }, [_vm._v("18")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "25"
    }
  }, [_vm._v("25")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Mês/Ano")]), _vm._v(" "), _c('datepicker', {
    attrs: {
      "language": _vm.ptBR,
      "minimum-view": "month",
      "format": "MMM/yyyy",
      "input-class": "form-control",
      "name": "competencia"
    },
    model: {
      value: (_vm.datepickerMes),
      callback: function($$v) {
        _vm.datepickerMes = $$v
      },
      expression: "datepickerMes"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('button', {
    staticClass: "btn btn-warning",
    staticStyle: {
      "margin-top": "1.8em"
    },
    on: {
      "click": function($event) {
        _vm.getFechamento()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped",
    attrs: {
      "aria-describedby": "example1_info",
      "role": "grid",
      "id": "example1"
    }
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.apiData.data), function(item) {
    return _c('tr', {
      staticClass: "even",
      attrs: {
        "role": "row"
      }
    }, [_c('td', [_vm._v(_vm._s(item.fantasia))]), _vm._v(" "), _c('td', [_vm._v("R$ " + _vm._s(_vm.number_format(item.total_restritiva, 2, ',', '.')))]), _vm._v(" "), _c('td', [_vm._v("R$ " + _vm._s(_vm.number_format(item.total_analitica, 2, ',', '.')))]), _vm._v(" "), _c('td', [_vm._v("R$ " + _vm._s(_vm.number_format(item.total, 2, ',', '.')))]), _vm._v(" "), _c('td', [_c('a', {
      attrs: {
        "title": "Imprimir",
        "href": "javascript:void(0)"
      },
      on: {
        "click": function($event) {
          _vm.imprimir(item.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-fw fa-print"
    })])])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-5"
  }, [_vm._v("\n                                Mostrando " + _vm._s(this.apiData.from) + " até " + _vm._s(this.apiData.to) + " de " + _vm._s(this.apiData.total) + " registros encontrados.\n                            ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-7",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('laravue-pagination', {
    attrs: {
      "data": _vm.apiData
    },
    on: {
      "pagination-change-page": _vm.getFechamento
    }
  }, [_c('span', {
    attrs: {
      "slot": "prev-nav"
    },
    slot: "prev-nav"
  }, [_vm._v("< Anterior")]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "next-nav"
    },
    slot: "next-nav"
  }, [_vm._v("Próximo >")])])], 1)])])])])])], 1)], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('b', [_vm._v("Relatório de Fechamento")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    attrs: {
      "role": "row"
    }
  }, [_c('th', {
    staticStyle: {
      "width": "55%"
    }
  }, [_vm._v("Fantasia")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v("C. Restritiva")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v("C. Analítica")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "15%"
    }
  }, [_vm._v("Total")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "10%"
    }
  }, [_vm._v("Ação")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1ee86806"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/fechamento/List.vue
// module id = 160
// module chunks = 1